import { Log } from '../models/Log';
import { PaginatedData, PaginationParams } from '../models/Pagination';
import httpClient from './httpClient';

function login(username: string, password: string) {
  return httpClient.post('/auth/login', { username, password });
}

function getDocuments() {
  return httpClient.get('/files');
}

function downloadDocument(fileKey: string) {
  return httpClient.get(`/files/download/`, { params: { key: fileKey } });
}

function removeDocument(id: string) {
  return httpClient.delete(`/files/${id}`);
}

function getLogs(params?: PaginationParams) {
  return httpClient.get<PaginatedData<Log>>(`/audit-logs/`, {
    params,
  });
}

function uploadDocument(document: File) {
  const formData = new FormData();
  formData.append('file', document);
  formData.append(
    'fileName',
    document.name.slice(0, document.name.lastIndexOf('.'))
  );

  return httpClient.post('/files/upload', formData);
}

function changeExpirationDays(id: string, downloadExpirationDays: number) {
  return httpClient.patch(`files/expiration-days/${id}`, {
    downloadExpirationDays,
  });
}

export default {
  login,
  getDocuments,
  downloadDocument,
  removeDocument,
  getLogs,
  uploadDocument,
  changeExpirationDays,
};
